//import { nine } from '@nine-lab/nine-util';

export class Trace {
	#name;
	#color;

	constructor(name = null, color = "green") {
		this.#name = name;
		this.#color = color;
	}

	init(name, color = "green") {
		this.#name = name;
		this.#color = color;
		return this;
	}

	/**
	 * 🎯 실시간 디버그 활성화 및 필터 타겟 여부 체크 헬퍼
	 */
	#isTraceEnabled() {
		// 1. 최상단 main.jsx에서 nine.setup() 세팅이 완료되었는지 확인
		if (nine && nine.config && nine.config.debug) {
			const debugConfig = nine.config.debug;

			// 🚨 디버그 마스터 스위치가 꺼져있으면 무조건 출력 안 함
			if (debugConfig.enable === false) {
				return false;
			}

			// 🎯 [필터 체크 추가] 디버그가 켜져있고, 필터(filter) 배열 명단이 존재하는 경우
			if (debugConfig.enable === true && Array.isArray(debugConfig.filter)) {
				// 이름이 지정 안 된 순정 trace.log는 통과, 이름이 있다면 필터 명단에 있어야만 통과!
				if (this.#name) {
					return debugConfig.filter.includes(this.#name);
				}
			}

			return debugConfig.enable;
		}

		// 2. [Fallback] 만약 nine 셋업 전에 호출되거나 세팅이 없다면 기존 로컬 주소 여부로 판단
		if (typeof window !== 'undefined') {
			return window.location.hostname === 'localhost' ||
				window.location.hostname === '127.0.0.1' ||
				window.location.hostname.startsWith('192.168.');
		}

		return false;
	}

	// 🔴 핵심: 소스 위치 유지를 위한 Getter 로직
	get log() {
		if (!this.#isTraceEnabled()) return () => {};

		const style = `color: ${this.#color}; font-weight: bold;`;
		return (this.#name)
			? console.log.bind(console, `%c[${this.#name}]`, style)
			: console.log.bind(console);
	}

	get warn() {
		if (!this.#isTraceEnabled()) return () => {};
		return (this.#name)
			? console.warn.bind(console, `%c[${this.#name}]`, "color: cyan; font-weight: bold;")
			: console.warn.bind(console);
	}

	get error() {
		// 시스템 치명적 장애 에러는 디버그 모드/필터 여부와 상관없이 실제 장애 모니터링을 위해 무조건 인쇄합니다.
		return (this.#name)
			? console.error.bind(console, `%c[${this.#name}]`, "color: red; font-weight: bold;")
			: console.error.bind(console);
	}
}

export const trace = new Trace();
if (typeof window !== 'undefined') window.trace = trace;